export default __webpack_public_path__ + "static/media/Doubly_List_Insertion_1.7d0df17f.gif";